import * as R from 'ramda';
import {
  takeLatest,
  select,
  delay,
  take,
} from 'redux-saga/effects';
import {
  ti2 as ti2Apis,
} from '../../../../api.js';
import { apiSaga, apiSagaJob } from '../../../../root-sagas.js';

export function* _getAccountInfo() {
  let account;
  while (true) {
    account = yield select(R.path(['account']));
    if (account && account.company && account.company.companyId) break;
    yield take('@app/GET_ACCOUNT_INFO_SUCCESS');
  }
  const {
    company: { companyId },
    travelMLSettings: {
      ti2: {
        token: ti2token,
      },
    },
  } = account;
  return { companyId, ti2token };
}

function* getAppKeyData({ payload }) {
  delay(2e3);
  const { ti2token } = yield _getAccountInfo();
  yield apiSagaJob('genAi_editAppKey_loadInitialData', ti2Apis.getAppKey, [{
    ...payload,
    ti2token,
  }])
}

function* saveConfiguration({ type }) {
  const { companyId, ti2token } = yield _getAccountInfo();
  const { configuration } = yield select(state => state.generativeAi.partnerSettings.editAppKey)
  const { hint, integrationApp } = yield select(state => state.generativeAi.partnerSettings.metadata)
  yield apiSaga(type, ti2Apis.updateAppKey, [{
    companyId,
    ti2token,
    configuration,
    hint,
    app: integrationApp,
  }])
}

// eslint-disable-next-line
export default [
  takeLatest('genAi_editAppKey_loadInitialData', getAppKeyData),
  takeLatest('genAi_editAppKey_saveConfiguration', saveConfiguration),
];
